import React from 'react'
import useMount from 'react-use/lib/useMount'
import { moment } from 'features/Moment'
import { compact } from 'lodash'

import TimelineList from 'components/TimelineList'
import TimelineListItem from 'components/TimelineList/TimelineListItem'
import LoadingLinear from 'components/Loading/LoadingLinear'

export default props => {
  useMount(() => {
    const { getServiceCases, serviceId } = props
    getServiceCases(serviceId)
  })

  const { cases, loading, showCasesViewModal } = props

  if (loading) {
    return (
      <TimelineList title="Timeline">
        <LoadingLinear />
      </TimelineList>
    )
  }

  return (
    <TimelineList title="Timeline">
      {cases.reverse().map(item => (
        <TimelineListItem
          key={item.id}
          onClick={() => showCasesViewModal({ caseItem: item })}
          hasClick
        >
          {compact([item.recordType, item.type, item.status]).join(' - ')}

          {item.modifiedAt && item.modifiedAt.date && (
            <span>&nbsp;-&nbsp;{moment(item.modifiedAt.date).fromNow()}</span>
          )}
        </TimelineListItem>
      ))}
      {!cases.length && <TimelineListItem>Related cases will appear here.</TimelineListItem>}
    </TimelineList>
  )
}



// WEBPACK FOOTER //
// ./~/@pickle/pickle-shared/src/features/Cases/CasesTimeline/CasesTimeline.jsx